import React, { useMemo } from 'react';
import { useGetOrganizationsLookup } from 'src/fetch/organizations';
import { FormSelect, FormMultiSelect } from '../formControls';
import { CUSTOMER_ORGANIZATION_ROLE } from 'src/shared/constants/enums';
import { emptyArray } from 'src/shared/helpers/utils';

const CustomerDropdown = (props) => {
  const { data: customerOrganizations = emptyArray, refetch } = useGetOrganizationsLookup({ roles: [CUSTOMER_ORGANIZATION_ROLE] });

  const calculatedCustomers = useMemo(() => customerOrganizations?.map((x) => ({
    ...x,
    label: x.name,
    value: x.id,
  })), [customerOrganizations]);

  const goesToLink = props.value?.value || props.value
    ? `/organizations/organizations/${props.value?.value ? props.value?.value : props.value}`
    : null;

  const SelectComponent = props.multiSelect ? FormMultiSelect : FormSelect;

  const itemRender = (li, itemProps) => {
    const recordNo = itemProps?.dataItem?.value || '';
    const itemChildren = (
      <span
        style={{
          display: 'flex',
          alignItems: 'space-between',
          width: '100%',
        }}
      >
        <div style={{
          flex: 1,
        }}
        >
          {li.props.children}
        </div>
        {
          recordNo && (
            <div
              style={{
                color: 'gray',
              }}
            >
              {`(${recordNo})`}
            </div>
          )
        }
      </span>
    );
    return React.cloneElement(li, li.props, itemChildren);
  };

  return (
    <div onClick={refetch}>
      <SelectComponent
        data={calculatedCustomers}
        textField='label'
        dataItemKey='value'
        goesTo={!props.hideGoesTo ? goesToLink : null}
        {...props}
        itemRender={itemRender}
        // valueRender={valueRender}
      />
    </div>
  );
};

export default CustomerDropdown;